import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import { Badge, Button } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import { formatDateMoment } from 'utils/utils'

export const TABLE_VOTING = {
    name: 'List Awards',
    column: [
        {
            name: 'Nama Awards',
            key: 'name',
        },
        {
            name: 'Periode',
            key: 'date_range',
            render: ({ value }) => {
                const splitRange = value.split(' - ')
                return (
                    <span>
                        {formatDateMoment(splitRange[0], 'DD MMMM YYYY HH:mm')} -{' '}
                        {formatDateMoment(splitRange[1], 'DD MMMM YYYY HH:mm')}
                    </span>
                )
            },
        },
        {
            name: 'Total Kategori',
            key: 'category_count',
        },
        {
            name: 'Total Sub Kategori',
            key: 'nomination_count',
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <div className={'flex gap-3'}>
                    <Button type={'outline'} title={'Detail'} onClick={() => onClickItem({ item })} />
                    {item.status !== 'complete' && (
                        <>
                            <Button
                                type={'outline'}
                                title={'Edit'}
                                icon={icEditYellow}
                                onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                            />
                            <Button
                                type={'outline'}
                                title={'Complete'}
                                onClick={() => onClickItem({ item, actionType: ACTION_TYPE.COMPLETE })}
                            />
                        </>
                    )}
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
